import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const LandOnDoc = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={color}
        d="M3 2.5H5.00001V13.5H3C2.44772 13.5 2 13.0523 2 12.5L2 3.5C2 2.94772 2.44771 2.5 3 2.5ZM13 2.5H6.00001V13.5H13C13.5523 13.5 14 13.0523 14 12.5V8.49412V3.5C14 2.94772 13.5523 2.5 13 2.5ZM13 1.5H3C1.89543 1.5 0.999998 2.39543 0.999998 3.5L1 12.5C1 13.6046 1.89543 14.5 3 14.5H13C14.1046 14.5 15 13.6046 15 12.5V8.49412V3.5C15 2.39543 14.1046 1.5 13 1.5ZM7.5 5C7.5 4.72386 7.72386 4.5 8 4.5H12C12.2761 4.5 12.5 4.72386 12.5 5C12.5 5.27614 12.2761 5.5 12 5.5H8C7.72386 5.5 7.5 5.27614 7.5 5ZM7.5 7C7.5 6.72386 7.72386 6.5 8 6.5H12C12.2761 6.5 12.5 6.72386 12.5 7C12.5 7.27614 12.2761 7.5 12 7.5H8C7.72386 7.5 7.5 7.27614 7.5 7ZM7.5 9C7.5 8.72386 7.72386 8.5 8 8.5H12C12.2761 8.5 12.5 8.72386 12.5 9C12.5 9.27614 12.2761 9.5 12 9.5H8C7.72386 9.5 7.5 9.27614 7.5 9ZM8 10.5C7.72386 10.5 7.5 10.7239 7.5 11C7.5 11.2761 7.72386 11.5 8 11.5H10C10.2761 11.5 10.5 11.2761 10.5 11C10.5 10.7239 10.2761 10.5 10 10.5H8Z"
      />
    </svg>
  )
})

export default LandOnDoc
